module.exports = __webpack_public_path__ + "assets/img/terminalPic3_app.5267f3b6.png";